// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3L0No","checkboxCol":"Table_checkboxCol__2Ewpd","emailCol":"Table_emailCol__19czb","actionCol":"Table_actionCol__21576"};